<template>
  <Teleport defer to="#portal_popup"> 
    <modal-window
      class="text-center"
      :modal_open="true"
      :is-form="false"
      :loading="loading"
      title="Create Design"
      @close="$emit('close')"
    >
      <div>
        <div class="touchFenestrationDesigner">
          <div class="touchFenestrationDesignerHeader">
            <label class="touchFenestrationDesignerHeaderTitle">TOUCH FENESTRATION DESIGNER</label>
          </div>

          <div class="touchFenestrationDesignerTab">
            <div class="touchFenestrationDesignerTabContents">
              <p>Width: <input id="touchFenestrationDesignerDesignWidth" class="touchFenestrationDesignerInput" oninput="this.className = ''"></p>
              <p>Height: <input id="touchFenestrationDesignerDesignHeight" class="touchFenestrationDesignerInput" oninput="this.className = ''"></p>
            </div>
          </div>

          <div id="touchFenestrationDesignerShape" class="touchFenestrationDesignerTab mx-auto" />

          <div id="touchFenestrationDesignerCouplers" class="touchFenestrationDesignerTab mx-auto" />

          <div id="touchFenestrationDesignerTransoms" class="touchFenestrationDesignerTab mx-auto" />

          <div id="touchFenestrationDesignerOpeners" class="touchFenestrationDesignerTab mx-auto" />

          <div id="touchFenestrationDesignerDummies" class="touchFenestrationDesignerTab mx-auto" />

          <div id="touchFenestrationDesignerSubOpeners" class="touchFenestrationDesignerTab mx-auto" />

          <div class="touchFenestrationDesignerFooter">
            <div class="touchFenestrationDesignerFooterToolbar">
              <div class="touchFenestrationDesignerFooterToolbarContainer" />

              <div class="gap-1 items-center mt-5 touchFenestrationDesignerFooterToolbarContainer">
                <button
                  id="touchFenestrationDesigner_Button_ShapeCustom" 
                  type="button"
                  class="btn btn-lg"
                  onclick="touchFenestrationDesigner_Shape_Custom()"
                >
                  Custom
                </button>
                <button
                  id="touchFenestrationDesigner_Button_ShapeRectangle" 
                  type="button"
                  class="btn btn-lg"
                  onclick="touchFenestrationDesigner_Shape_Rectangle()"
                >
                  Rectangle
                </button>
              </div>

              <div class="touchFenestrationDesignerFooterToolbarContainer" />

              <div class="touchFenestrationDesignerFooterToolbarContainer" />

              <div class="touchFenestrationDesignerFooterToolbarContainer">
                <select id="touchFenestrationDesigner_Openers" onchange="touchFenestrationDesigner_Openers_onchange(this)">
                  <option value="0">Select opener</option>
                  <option value="21">Casement (THL)</option>
                  <option value="22">Casement (THR)</option>
                  <option value="23">Casement (LH)</option>
                  <option value="24">Casement (RH)</option>
                  <option value="25">Casement (French)</option>
                  <option value="26">Casement (Fixed)</option>
                  <option value="31">Tilt & Turn (LH)</option>
                  <option value="32">Tilt & Turn (RH)</option>
                  <option value="33">Tilt & Turn (Fixed)</option>
                  <option value="41">Door (LH)</option>
                  <option value="42">Door (RH)</option>
                  <option value="43">Door (French)</option>
                </select>
              </div>

              <div class="touchFenestrationDesignerFooterToolbarContainer">
                <select id="touchFenestrationDesigner_Dummies" onchange="touchFenestrationDesigner_Dummies_onchange(this)">
                  <option value="0">Select dummy/midrail</option>
                  <option value="13">Dummy</option>
                  <option value="14">Midrail</option>
                </select>
              </div>

              <div class="touchFenestrationDesignerFooterToolbarContainer">
                <select id="touchFenestrationDesigner_SubOpeners" onchange="touchFenestrationDesigner_SubOpeners_onchange(this)">
                  <option value="0">Select sub-opener</option>
                  <option value="21">Casement (THL)</option>
                  <option value="22">Casement (THR)</option>
                  <option value="23">Casement (LH)</option>
                  <option value="24">Casement (RH)</option>
                  <option value="31">Tilt & Turn (LH)</option>
                  <option value="32">Tilt & Turn (RH)</option>
                </select>
              </div>

              <div class="touchFenestrationDesignerFooterToolbarContainer">
                <select id="touchFenestrationDesigner_Apertures" onchange="=touchFenestrationDesigner_Apertures_onchange(this)">
                  <option value="0">Select aperture</option>
                  <option value="1001">Glass</option>
                  <option value="1011">Panel (Door)</option>
                  <option value="1012">Panel (Half)</option>
                  <option value="1013">Panel (Flat)</option>
                </select>
              </div>

              <div class="touchFenestrationDesignerFooterToolbarContainer" />
            </div>

            <div class="flex gap-1 items-center mt-5 touchFenestrationDesignerFooterNavButtons">
              <button
                id="touchFenestrationDesigner_Button_Reset"
                type="button"
                onclick="touchFenestrationDesigner_Reset()"
                class="btn btn-lg"
              >
                Reset
              </button>
              <button
                id="touchFenestrationDesigner_Button_Next"
                type="button"
                class="btn btn-action btn-lg"
                onclick="touchFenestrationDesigner_Next()"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </modal-window>
  </Teleport>
</template>

<script>

import { mapStores } from 'pinia'
import { useBasketStore } from '@/pinia/basket';

window.touchFenestrationDesigner_PostDesign = function () {
  const event = new Event('touchFenestrationDesigner_PostDesign');
  window.dispatchEvent(event);
};

export default {
  props: {
    selectedProductId: Number,
    url: String
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapStores(useBasketStore),
  },
  mounted() {
    window.touchFenestrationDesigner_CurrentTab = 0
    window.touchFenestrationDesigner_ShowTab()
    window.addEventListener('touchFenestrationDesigner_PostDesign', this.postDesign);
  },
  beforeUnmount() {
    window.removeEventListener('touchFenestrationDesigner_PostDesign', this.postDesign);
  },
  methods: {
    async postDesign(event) {
      this.loading = true
      const itemKey = await this.basketStore.addDesignFromDesigner({
        Design: window.touchFenestrationDesigner_CurrentDesign,
        BusinessProductId: this.selectedProductId
      })
      window.touchFenestrationDesigner_CurrentTab = 0
      window.touchFenestrationDesigner_Reset()
      this.routerPush(`${this.url}/design/${itemKey}`);
      this.$emit('close')
    },
  }
}

</script>

<style>
.touchFenestrationDesigner {
  margin: 0px auto;
  width: 100%;
  min-width: 300px;
  height: 100%;
}

.touchFenestrationDesignerHeader {
  font-size: 16pt;
  overflow: auto;
  margin-bottom: 20px;
  text-align: center;
  width: 100%;
}

.touchFenestrationDesignerFooter {
  font-size: 16pt;
  overflow: auto;
  margin-top: 20px;
  text-align: center;
  width: 100%;
}

.touchFenestrationDesignerFooterToolbar {
  float: left;
}

.touchFenestrationDesignerFooterToolbarContainer {
  display: none;
}

.touchFenestrationDesignerFooterNavButtons {
  float: right;
}

.touchFenestrationDesignerTab {
  display: none;
  justify-content: center;
  align-items: center;
  height: 100%;
  max-width: 500px;
}

.touchFenestrationDesignerTabContents {
  display: inline;
}

.touchFenestrationDesignerSvg {
  width: 100%;
  height: 100%;
}

.touchFenestrationDesignerInput {
  padding: 10px;
  width: 100px;
}

.touchFenestrationDesignerInput:invalid {
  background-color: #ffdddd;
}

.touchFenestrationDesignerBenignGridLine {
  stroke: lightgrey;
  stroke-width: 1px;
}

.touchFenestrationDesignerGridDot {
  fill: lightgrey;
  pointer-events: all;
}

.touchFenestrationDesignerGridDot:hover {
  r: 20;
}

.touchFenestrationDesignerGridDotSelected {
  fill: red;
  pointer-events: all;
}

.touchFenestrationDesignerGridDotSelected:hover {
  r: 20;
}

.touchFenestrationDesignerActiveGridLine {
  stroke: lightgrey;
  stroke-width: 9px;
  pointer-events: all;
}

.touchFenestrationDesignerActiveGridLine:hover {
  stroke: darkgrey;
  stroke-width: 19px;
}

.touchFenestrationDesignerRoot {
  fill: none;
  stroke: darkgrey;
  stroke-width: 9px;
}

.touchFenestrationDesignerFrame {
  fill: none;
  stroke: black;
  stroke-width: 9px;
}

.touchFenestrationDesignerCouplerLine {
  stroke: blue;
  stroke-width: 3px;
}

.touchFenestrationDesignerTransomLine {
  stroke: black;
  stroke-width: 9px;
}

.touchFenestrationDesignerHingeLine {
  fill: none;
  stroke: black;
  stroke-width: 5px;
}

.touchFenestrationDesignerApertureGlass {
  fill: paleturquoise;
  pointer-events: all;
}
</style>